import { render, staticRenderFns } from "./RouteAction.vue?vue&type=template&id=04b59182&scoped=true"
import script from "./RouteAction.vue?vue&type=script&lang=js"
export * from "./RouteAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b59182",
  null
  
)

export default component.exports